import { GridBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/gridBlock/gridBlock'
import { GridBlock } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/blocks.state'
import { StyleguideExample, StyleguidePart } from '@shared/Hoppinger.Styleguide/Frontend'
import * as React from 'react'
import { dummyData, randomCaption, randomTitle, randomWords } from '../../../config/dummyData'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentsGridBlock = () => (
  <>
    <StyleguidePart title="Text-only" intro="White background (default):">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentGridBlock variant="text" />
      </StyleguideExample>
    </StyleguidePart>
    <StyleguidePart intro="Grey background:">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentGridBlock variant="text" bgColour="grey" />
      </StyleguideExample>
    </StyleguidePart>
    <StyleguidePart title="Text and Images" intro="White background (default):">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentGridBlock variant="image" />
      </StyleguideExample>
    </StyleguidePart>
    <StyleguidePart intro="Grey background:">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentGridBlock variant="image" bgColour="grey" />
      </StyleguideExample>
    </StyleguidePart>
    <StyleguidePart title="2 items" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentGridBlock variant="image" twoItems />
      </StyleguideExample>
    </StyleguidePart>
    <StyleguidePart
      title="With carousel"
      intro="With carousel (enabled in image grid if there are 4 or more items, or on mobile (<768px) if there are 3 or more items)"
    >
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentGridBlock variant="image" enableCarousel />
      </StyleguideExample>
    </StyleguidePart>

    {/* Not used in Van Oord: */}
    {/* <StyleguidePart title="Text and Icons" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentGridBlock variant="icon" />
      </StyleguideExample>
    </StyleguidePart> */}
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentGridBlock = (props: {
  variant: GridBlock['variant']
  items?: GridBlock['items']
  bgColour?: GridBlock['bgColour']
  enableCarousel?: boolean
  twoItems?: boolean
}) => (
  <GridBlockLayout
    id="grid-block-example"
    bgColour={props.bgColour || 'white'}
    title={randomTitle()}
    intro={dummyData.intro}
    primaryUpdater={dummyData.primaryUpdater}
    variant={props.variant}
    items={
      props.items || props.variant == 'text'
        ? itemsText.slice(0, props.twoItems ? 2 : undefined)
        : itemsImage(props.enableCarousel).slice(0, props.twoItems ? 2 : undefined)
    }
    enableCarousel={props.enableCarousel}
    viewportWidth={window.innerWidth}
  />
)

const itemsText: GridBlock['items'] = [
  {
    intro: randomCaption(),
    title: randomTitle(),
    label: randomWords(),
    link: dummyData.secondaryUpdater
  },
  {
    intro: randomCaption(),
    title: randomTitle(),
    label: randomWords(),
    link: dummyData.primaryUpdater
  },
  {
    intro: randomCaption(),
    title: randomTitle(),
    label: randomWords(),
    link: dummyData.primaryUpdater
  }
]

const itemsImage = (carousel?: boolean): GridBlock['items'] => [
  {
    intro: randomCaption(),
    title: randomTitle(),
    label: randomWords(),
    link: { ...dummyData.secondaryUpdater, title: randomWords() },
    image: dummyData.image
  },
  {
    intro: randomCaption(),
    title: randomTitle(),
    label: randomWords(),
    link: { ...dummyData.primaryUpdater, title: randomWords() },
    image: dummyData.imageFjords
  },
  {
    intro: randomCaption(),
    title: randomTitle(),
    label: randomWords(),
    link: { ...dummyData.secondaryUpdater, title: randomWords() },
    image: dummyData.image
  },
  ...(carousel
    ? [
        {
          intro: randomCaption(),
          title: randomTitle(),
          label: randomWords(),
          image: dummyData.imageFjords,
          link: dummyData.secondaryUpdater
        },
        {
          intro: randomCaption(),
          title: randomTitle(),
          label: randomWords(),
          image: dummyData.image,
          link: dummyData.primaryUpdater
        },
        {
          intro: randomCaption(),
          title: randomTitle(),
          label: randomWords(),
          image: dummyData.imageFjords,
          link: dummyData.primaryUpdater
        }
      ]
    : [])
]
